import { FormResource } from "../locales";

export const form: FormResource = {
    rangeOverflow: "Der Wert darf max. {{max}} betragen.",
    rangeUnderflow: "Der Wert muss mind. {{min}} betragen.",
    required: "Dieses Feld ist ein Pflichtfeld.",
    invalidEmail: "Ungültige E-Mail-Adresse.",
};
